'use client';

import {
  QueryClient,
  QueryClientConfig,
  QueryClientProvider,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { defaultQueryOptions } from '@/services/utils';

export const ReactQueryContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const QueryClientOptions: QueryClientConfig = {
    defaultOptions: { queries: defaultQueryOptions },
  };

  const queryClient = new QueryClient(QueryClientOptions);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools panelProps={{ style: { direction: 'ltr' } }} />
      {children}
    </QueryClientProvider>
  );
};
